import genericErrorIcon from "../../../images/generic-error.svg";
import { useMediaQuery } from "../../hooks/useMediaQuery";
import { MGButton } from "../MGButton";
import { MGSubtitle } from "../MGSubtitle";
import { MGText } from "../MGText";
import styles from "./MGGenericError.module.css";

export type TMGGenericErrorProps = {
  title: string;
  description?: string;
  actionsAtBottom?: boolean;
  primaryActionLabel: string;
  secondaryActionLabel: string;
  onPrimaryAction: VoidFunction;
  onSecondaryAction: VoidFunction;
};

export const MGGenericError = ({
  title,
  description,
  actionsAtBottom = false,
  primaryActionLabel,
  secondaryActionLabel,
  onPrimaryAction,
  onSecondaryAction,
}: TMGGenericErrorProps) => {
  const isMobile = useMediaQuery("(max-width: 767px)");

  return (
    <div className={styles.root} data-actions-at-bottom={actionsAtBottom}>
      <div className={styles.content}>
        <img src={genericErrorIcon} alt="" width={160} height={160} className={styles.icon} />

        <div className={styles.message}>
          <MGSubtitle subtitleStyleDefinition="200-06" className={styles.centeredText}>
            {title}
          </MGSubtitle>

          {description && (
            <MGText textStyleDefinition="body-100-03" className={styles.centeredText}>
              {description}
            </MGText>
          )}
        </div>
      </div>

      <div className={styles.actions}>
        <MGButton fullWidth onClick={onPrimaryAction}>
          {primaryActionLabel}
        </MGButton>
        <MGButton
          fullWidth
          appearance={isMobile ? "tertiary" : "secondary"}
          onClick={onSecondaryAction}>
          {secondaryActionLabel}
        </MGButton>
      </div>
    </div>
  );
};
